<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group" v-if="brandBrief.length > 1">
          <select class="form-control h-38" v-model="brandSelect" @change="clickSearch">
            <option v-for="brand in brandBrief" :value="brand.value">
              {{brand.label}}
            </option>
          </select>
        </div>
        <div class="form-group" v-if="storeBrief.length > 1">
          <select class="form-control h-38" v-model="storeSelect" @change="clickSearch">
            <option v-for="store in storeBrief" :value="store.value">
              {{store.label}}
            </option>
          </select>
        </div>
      </div>
      <!--訂購總人數會減少 其餘統計數字不變-->
      <!-- 訂購總人數 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">
        <div class="info-box">
          <span class="info-box-icon bg-red"><i class="ion ion-ios-people"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">訂購總人數</span>
            <span class="info-box-number text-35">{{platformMoney.shopper_count}}</span>
          </div>
        </div>
      </div>
      <!-- 累積成交訂單數量 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">
        <div class="info-box">
          <span class="info-box-icon bg-aqua"><i class="ion ion-document-text"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積成交訂單數量</span>
            <span class="info-box-number text-35">{{platformMoney.order_count_total}}</span>
          </div>
        </div>
      </div>
      <!-- 累積成交訂單金額 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">
        <div class="info-box">
          <span class="info-box-icon bg-green"><i class="ion ion-cash"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積成交訂單金額</span>
            <span class="info-box-number text-35">{{platformMoney.order_money_total}}</span>
          </div>
        </div>
      </div>
      <!-- 累積成交商品數量 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10">
        <div class="info-box">
          <span class="info-box-icon bg-light-blue"><i class="ion ion-wineglass"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積成交商品數量</span>
            <span class="info-box-number text-35">{{platformMoney.item_count_total}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box-body">
        <div class="box-body p-0 col-xs-12">
          <div class="col-xs-12">
            <div class="col-sm-6 col-xs-12 text-left">
              <div class="m-b-15">
                <ion-icon name="list-box"></ion-icon> 期間內成交訂單數量： {{platformMoney.order_count_seg}} 筆<br>
                <i class="ion ion-cash"></i> 期間內成交訂單金額： {{platformMoney.order_money_seg}} 元<br>
                <ion-icon name="restaurant"></ion-icon> 期間內成交商品數量： {{platformMoney.item_count_seg}} 份
              </div>
            </div>
            <div class=" col-xs-12 col-sm-6 text-right pull-right">
              <div class="form-group input-group time-box pull-right">
                <date-time-picker :date="menuTime.start" :option="dateoption" :limit="startLimit"></date-time-picker>
                <date-time-picker :date="menuTime.end" :option="dateoption" :limit="endLimit"></date-time-picker>
                <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                <span class="input-group-btn">
              <button class="btn btn-default submit-btn btn-search" type="button"
                      id="search2" style="height: 72px" @click="clickSearch()">
                <i class="fa fa-search"></i>
              </button>
            </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
              <thead>
              <tr>
                <th rowspan="2">#</th>
                <th rowspan="2">使用者</th>
                <th class="th-fit c-pointer" rowspan="2" v-if="roleType === 99" @click="checkSort('shopper_id')">ID
                  <span v-if="sortMethod === 'shopper_id'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th rowspan="1" colspan="2"><ion-icon name="list-box"></ion-icon> 成交訂單數</th>
                <th rowspan="1" colspan="2"><i class="ion ion-cash"></i> 成交訂單金額</th>
                <th rowspan="1" colspan="2"><ion-icon name="restaurant"></ion-icon> 成交商品數</th>
                <th rowspan="2"></th>
              </tr>
              <tr>
                <th class="th-fit c-pointer" @click="checkSort('order_count_seg')">期間
                  <span v-if="sortMethod === 'order_count_seg'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th class="th-fit c-pointer" @click="checkSort('order_count_total')">累積
                  <span v-if="sortMethod === 'order_count_total'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th class="th-fit c-pointer" @click="checkSort('money_seg')">期間
                  <span v-if="sortMethod === 'money_seg'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th class="th-fit c-pointer" @click="checkSort('money_total')">累積
                  <span v-if="sortMethod === 'money_total'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th class="th-fit c-pointer" @click="checkSort('item_count_seg')">期間
                  <span v-if="sortMethod === 'item_count_seg'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
                <th class="th-fit c-pointer" @click="checkSort('item_count_total')">累積
                  <span v-if="sortMethod === 'item_count_total'">
                    <i class="fa fa-caret-up" aria-hidden="true" v-if="sortToggle"></i>
                    <i class="fa fa-caret-down" aria-hidden="true" v-else></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-sort" aria-hidden="true"></i>
                  </span>
                </th>
              </tr>
              </thead>
              <tbody v-if="isLoading">
                <tr>
                  <td colspan="12" class="text-center">資料讀取中......</td>
                </tr>
              </tbody>
              <tbody v-else-if="shopperMoneyList.length === 0">
                <tr style="background-color: white">
                  <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                    <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                    <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="shopperMoneyList.length > 0">
                <tr class="even" role="row" v-for="(shopper, index) in shopperMoneyList">
                  <td>{{index + 1}}</td>
                  <td>
                    <router-link :to="'/memberOrderTable/' + shopper.shopper_id" target="_blank">
                      {{shopper.user_no}}
                      | {{shopper.nickname}}
                      <span v-if="shopper.last_name || shopper.first_name"> ({{shopper.last_name}}{{shopper.first_name}})</span>
                    </router-link>
                  </td>
                  <td v-if="roleType === 99">{{shopper.shopper_id}}</td>
                  <td>{{shopper.order_count_seg}}</td>
                  <td>{{shopper.order_count_total}}</td>
                  <td>{{shopper.money_seg}}</td>
                  <td>{{shopper.money_total}}</td>
                  <td>{{shopper.item_count_seg}}</td>
                  <td>{{shopper.item_count_total}}</td>
                  <td>
                    <button class="btn btn-default" data-toggle="modal" data-target="#shopperMoneyModal" @click="openModal(shopper)">
                      <i class="ion ion-cash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-xs-12 text-center">
            <ul class="pagination">
              <li class="paginate_button" @click="clickEnd('pre')">
                <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button"  @click="clickGroup('left')">
                <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
                <a class="c-pointer">{{index}}</a>
              </li>
              <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
                <a class="c-pointer">&nbsp;&nbsp;</a>
              </li>
              <li class="paginate_button" @click="clickGroup('right')">
                <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
              </li>
              <li class="paginate_button" @click="clickEnd('forward')">
                <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="shopperMoneyModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{shopperInfo.nickname}}消費統計</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable text-center">
                  <thead>
                  <tr>
                    <th colspan="2"><ion-icon name="list-box"></ion-icon> 成交訂單數</th>
                    <th colspan="2"><i class="ion ion-cash"></i> 成交訂單金額</th>
                    <th colspan="2"><ion-icon name="restaurant"></ion-icon> 成交商品數</th>
                  </tr>
                  <tr>
                    <th class="c-pointer">期間</th>
                    <th class="c-pointer">累積</th>
                    <th class="c-pointer">期間</th>
                    <th class="c-pointer">累積</th>
                    <th class="c-pointer">期間</th>
                    <th class="c-pointer">累積</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr role="row">
                    <td>{{shopperInfo.order_count_seg}} / {{platformMoney.order_count_seg}}</td>
                    <td>{{shopperInfo.order_count_total}} / {{platformMoney.order_count_total}}</td>
                    <td>{{shopperInfo.money_seg}} / {{platformMoney.order_money_seg}}</td>
                    <td>{{shopperInfo.money_total}} / {{platformMoney.order_money_total}}</td>
                    <td>{{shopperInfo.item_count_seg}} / {{platformMoney.item_count_seg}}</td>
                    <td>{{shopperInfo.item_count_total}} / {{platformMoney.item_count_total}}</td>
                  </tr>
                  <tr role="row">
                    <td :class="{'text-red': getPercent(shopperInfo.order_count_seg, platformMoney.order_count_seg) > 0.01}">{{getPercent(shopperInfo.order_count_seg, platformMoney.order_count_seg)}}％</td>
                    <td :class="{'text-red': getPercent(shopperInfo.order_count_total, platformMoney.order_count_total) > 0.01}">{{getPercent(shopperInfo.order_count_total, platformMoney.order_count_total)}}％</td>
                    <td :class="{'text-red': getPercent(shopperInfo.money_seg, platformMoney.order_money_seg) > 0.01}">{{getPercent(shopperInfo.money_seg, platformMoney.order_money_seg)}}％</td>
                    <td :class="{'text-red': getPercent(shopperInfo.money_total, platformMoney.order_money_total) > 0.01}">{{getPercent(shopperInfo.money_total, platformMoney.order_money_total)}}％</td>
                    <td :class="{'text-red': getPercent(shopperInfo.item_count_seg, platformMoney.item_count_seg) > 0.01}">{{getPercent(shopperInfo.item_count_seg, platformMoney.item_count_seg)}}％</td>
                    <td :class="{'text-red': getPercent(shopperInfo.item_count_total, platformMoney.item_count_total) > 0.01}">{{getPercent(shopperInfo.item_count_total, platformMoney.item_count_total)}}％</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      roleType: 99,
      shopperMoney: {},
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 20,
      platformMoney: {},
      shopperMoneyList: [],
      sortToggle: false,
      sortMethod: '',
      preSortMethod: [],
      brandIds: '',
      storeIds: '',
      shopperInfo: {
      },
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      brandBrief: [],
      storeBrief: [],
      brandSelect: 0,
      storeSelect: 0,
      isLoading: true
    }
  },
  methods: {
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    getPercent (son, mom) {
      var p = son / mom
      var result = Math.ceil(p * 10000) / 100
      if (isNaN(result)) return 0
      return result
    },
    openModal (shopper) {
      this.shopperInfo = shopper
    },
    checkSort (method) {
      this.sortMethod = method
      if (this.preSortMethod.length) {
        if (method === this.preSortMethod[0]) this.sortToggle = !this.sortToggle
        else {
          this.tableIndex = 1
          this.sortToggle = false
        }
        this.preSortMethod.splice(0, 1)
      } else this.sortToggle = false
      this.preSortMethod.push(method)
      this.getShopperMoney()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getShopperMoney()
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getShopperMoney () {
      this.isLoading = true
      var self = this
      const data = {
        page: this.tableIndex,
        count: this.count,
        start_date: moment(this.menuTime.start.time, 'YYYY-MM-DD').format('YYYYMMDD'),
        end_date: moment(this.menuTime.end.time, 'YYYY-MM-DD').format('YYYYMMDD')
      }
      var domain = ''
      if (this.roleType === 99) domain = 'shopperMoney?'
      else if (this.roleType === 30) domain = 'brandShopperMoney?brand_id=' + this.brandSelect + '&'
      else if (this.roleType === 10) domain = 'storeShopperMoney?store_id=' + this.storeSelect + '&'
      var url = 'statistic/' + domain + 'page=' + data.page + '&size=' + data.count + '&start_date=' + data.start_date + '&end_date=' + data.end_date
      if (this.sortMethod) {
        url = url + '&list_sort=' + this.sortMethod + ' '
        if (this.sortToggle) url = url + 'ASC'
        else url = url + 'DESC'
      }
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          if (self.roleType === 99) {
            self.total = response.data.shopper_statistic.shopper_money_list_total
            self.platformMoney = response.data.shopper_statistic.platform_money
            self.shopperMoneyList = response.data.shopper_statistic.shopper_money_list
          } else if (self.roleType === 30) {
            self.total = response.data.brand_shopper_statistic.shopper_money_list_total
            self.platformMoney = response.data.brand_shopper_statistic.brand_money
            self.shopperMoneyList = response.data.brand_shopper_statistic.shopper_money_list
          } else if (self.roleType === 10) {
            self.total = response.data.store_shopper_statistic.shopper_money_list_total
            self.platformMoney = response.data.store_shopper_statistic.store_money
            self.shopperMoneyList = response.data.store_shopper_statistic.shopper_money_list
          }
          self.isLoading = false
        }
      })
    },
    clickSearch () {
      this.tableIndex = 1
      this.pageGroup = 1
      this.getShopperMoney()
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            brandIds = brandIds + bList[i].brand_id + ','
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj.value
          }
          brandIds = brandIds.slice(0, -1)
          self.brandIds = brandIds
          if (self.roleType === 30) self.getShopperMoney()
          else self.getStoreBrief(brandIds)
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | ShopperMoneyTableTemp')
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          var storeIds = ''
          for (let i = 0; i < sList.length; i++) {
            storeIds = storeIds + sList[i].store_id + ','
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0) self.storeSelect = obj.value
          }
          storeIds = storeIds.slice(0, -1)
          self.storeIds = storeIds
          self.getShopperMoney()
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    var date = new Date()
    var y = date.getFullYear()
    var m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    this.menuTime.start.time = moment(firstDay).format('YYYY-MM-DD')
    this.fixedH()
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
    if (roleType === 30 || roleType === 10) this.getBrandBrief()
    else this.getShopperMoney()
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    }
  }
}
</script>
<style lang="sass">
</style>




// WEBPACK FOOTER //
// ShopperMoneyTableTemp.vue?f0a7d834